<div *ngIf="date" class="date-time">
	{{ date | date : 'EEEE, LLL d' }}
</div>
